export default __webpack_public_path__ + "static/product_item_005-b1e79097778f1da57a0263dafcc902d7.jpg";